module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/college-of-charleston-0d55a577e5e587c05d3de70dfa70f2e4.jpg";